// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WaveDivider_wrapper__Fd2iX {
  width: 100%;
  display: block;
  margin: -2px 0;
  pointer-events: none;
  line-height: 0;
  overflow: hidden;
}

.WaveDivider_flip__-y8dq {
  transform: scaleY(-1);
}

.WaveDivider_svg__OdPNd {
  display: block;
  width: 100%;
  height: 60px;
}

@media (max-width: 768px) {
  .WaveDivider_svg__OdPNd {
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/WaveDivider.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  display: block;\n  margin: -2px 0;\n  pointer-events: none;\n  line-height: 0;\n  overflow: hidden;\n}\n\n.flip {\n  transform: scaleY(-1);\n}\n\n.svg {\n  display: block;\n  width: 100%;\n  height: 60px;\n}\n\n@media (max-width: 768px) {\n  .svg {\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `WaveDivider_wrapper__Fd2iX`,
	"flip": `WaveDivider_flip__-y8dq`,
	"svg": `WaveDivider_svg__OdPNd`
};
export default ___CSS_LOADER_EXPORT___;
